/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lib_Profile_Notfound1Inputs */

const en_lib_profile_notfound1 = /** @type {(inputs: Lib_Profile_Notfound1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile not found`)
};

/**
* | output |
* | --- |
* | "Profile not found" |
*
* @param {Lib_Profile_Notfound1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const lib_profile_notfound1 = /** @type {((inputs?: Lib_Profile_Notfound1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lib_Profile_Notfound1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lib_profile_notfound1(inputs)
});
export { lib_profile_notfound1 as "lib.profile.notFound" }